import { defineStore } from "pinia";
import { ref } from "vue";
import { storage } from "/@/cool/utils";
import { service } from "/@/cool";

// 本地缓存
const data = storage.info();

export const useProductStore = defineStore("product", function () {
	const buyTypeCateList = ref<any[]>(data["product.buyTypeCateList"] || []);
	const buyTypeCateListUsePosition = ref<any[]>(data["product.buyTypeCateListUsePosition"] || []);

	// 设置菜单组
	function setBuyTypeCateList(list: any) {
		buyTypeCateList.value = list.map((item: any) => ({
			label: item.cate_name,
			value: item.id
		}));
		storage.set("product.buyTypeCateList", buyTypeCateList.value);
		buyTypeCateListUsePosition.value = list
			.filter((item: any) => item.use_position == 1)
			.map((item: any) => ({
				label: item.cate_name,
				value: item.id
			}));
		storage.set("product.buyTypeCateListUsePosition", buyTypeCateListUsePosition.value);
	}

	async function getBuyTypeCateList() {
		// 检查 service 和 buyTypeCate 是否存在
		if (!service || !service.buyTypeCate) {
			console.warn("service.buyTypeCate 尚未初始化");
			return [];
		}
		const res = await service.buyTypeCate.list({ is_active: 1 });
		const ret = res || [];
		return ret;
	}

	function loadBuyTypeCateList() {
		getBuyTypeCateList()
			.then((res) => {
				setBuyTypeCateList(res);
			})
			.catch((err) => {
				console.error("加载 buyTypeCateList 失败:", err);
			});
	}

	return {
		getBuyTypeCateList,
		setBuyTypeCateList,
		buyTypeCateList,
		buyTypeCateListUsePosition,
		loadBuyTypeCateList,
		refreshBuyTypeCateList: loadBuyTypeCateList
	};
});
